module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/library/modules/_library.js
// module id = 172
// module chunks = 0